<template>
  <div class="thumbnailCard">
    <div
      v-for="i in 2"
      :key="`thumbnailCard-wrapper-${i}`"
      class="thumbnailCard__wrapper"
      :class=" i === 1 ? 'thumbnailCard__wrapper--left' : 'thumbnailCard__wrapper--right'"
    >
      <template
        v-for="(item, index) in cardList[i - 1]">
        <div
          :key="`thumbnailCard-${index}`"
          class="thumbnailCard__card">
          <img
            class="thumbnailCard__card__img"
            :src="getImgPath(item.thumbnails)" alt="">
          <p class="thumbnailCard__card__title">{{ item.title }}</p>
        </div>
      </template>
    </div>
  </div>
</template>

<script>
// eslint-disable-next-line no-unused-vars
import { gsap } from 'gsap'

export default {
  name: 'ThumbnailCard',
  data () {
    return {
      data: [
        {
          title: 'Mobilités et métissages',
          thumbnails: '2014-12-5_1.jpg'
        },
        {
          title: 'Mobilités et métissages',
          thumbnails: '2014-13-10_1.jpg'
        },
        {
          title: 'Arts du spectacle',
          thumbnails: '2015-1-21_1.jpg'
        },
        {
          title: 'Corps, apparences, sexualités',
          thumbnails: '2015-6-2_p1_1.jpg'
        },
        {
          title: 'Croyances et religions',
          thumbnails: '2016-12-16-p1_1.jpg'
        },
        {
          title: 'Art contemporain',
          thumbnails: '2018-5-4-p1_1.jpg'
        },
        {
          title: 'Artisanat, commerce, industrie',
          thumbnails: '2015-7-1-p1_1.jpg'
        },
        {
          title: 'Arts du spectacle',
          thumbnails: '2018-72-4-p1_1.jpg'
        },
        {
          title: 'Vie publique',
          thumbnails: '2019-12-2-p1_1.jpg'
        },
        {
          title: 'Art contemporain',
          thumbnails: '2020-11-1-1-3-p1_1.jpg'
        },
        {
          title: 'Art contemporain',
          thumbnails: '2021-15-3-p1_1.jpg'
        },
        {
          title: 'Art contemporain',
          thumbnails: '2022-6-2-p2_1.jpg'
        },
        {
          title: 'Sport et santé',
          thumbnails: 'ph-2014-1-1214_1.jpg'
        }
      ],
      cardList: []
    }
  },
  props: {
    animate: {
      type: Boolean,
      default: false
    }
  },
  watch: {
    animate (val) {
      if (val) {
        if (!this.$tools.isMobile()) {
          this.animate_showreal()
        } else {
          setTimeout(() => {
            console.log('mobile')
            const right = document.querySelector('.thumbnailCard__wrapper--right').offsetWidth
            const left = document.querySelector('.thumbnailCard__wrapper--left').offsetWidth
            const length = (right + left) - window.innerWidth
            console.log(length)
            gsap.to('.thumbnailCard', {
              x: -length,
              opacity: 1,
              duration: 30,
              ease: 'linear',
              repeat: -1
            })
          }, 1000)
        }
      }
    }
  },
  mounted () {
    this.init_showreal(this.data)
  },
  methods: {
    init_showreal (data) {
      console.log('init showreal')
      const isPair = data.length % 2 === 0
      if (!isPair) {
        console.warn('Home thumbnailCard data is not pair, removing last item')
        data.pop()
      }

      const half = Math.ceil(data.length / 2)
      this.cardList.push(data.splice(0, half))
      this.cardList.push(data.splice(-half))
    },
    animate_showreal () {
      // TODO: refactor this
      const target = {
        parent: document.querySelector('.thumbnailCard'),
        right: {
          el: document.querySelector('.thumbnailCard__wrapper--right'),
          elHeight: null,
          childes: document.querySelectorAll('.thumbnailCard__wrapper--right .thumbnailCard__card'),
          childesHeight: document.querySelector('.thumbnailCard__wrapper--right .thumbnailCard__card').offsetHeight + 15
        },
        left: {
          el: document.querySelector('.thumbnailCard__wrapper--left'),
          elHeight: null,
          childes: document.querySelectorAll('.thumbnailCard__wrapper--left .thumbnailCard__card'),
          childesHeight: document.querySelector('.thumbnailCard__wrapper--left .thumbnailCard__card').offsetHeight + 15
        }
      }

      target.right.elHeight = target.right.childes.length * target.right.childesHeight
      target.left.elHeight = target.left.childes.length * target.left.childesHeight

      gsap.set(target.right.childes, {
        y: (i) => i * target.right.childesHeight
      })
      gsap.set(target.left.childes, {
        y: (i) => i * target.right.childesHeight
      })

      // gsap.fromTo(target.parent, { opacity: 0 }, { opacity: 1, duration: 1 })

      const wrapRight = gsap.utils.wrap(-target.right.childesHeight, target.right.elHeight - target.right.childesHeight)
      const wrapLeft = gsap.utils.wrap(-target.left.childesHeight, target.left.elHeight - target.left.childesHeight)
      const duration = 50

      gsap.to(target.right.childes, {
        duration,
        ease: 'none',
        y: `-=${target.right.elHeight}`,
        modifiers: {
          y: gsap.utils.unitize(wrapRight)
        },
        repeat: -1
      })

      gsap.to(target.left.childes, {
        duration,
        ease: 'none',
        y: `+=${target.left.elHeight}`,
        modifiers: {
          y: gsap.utils.unitize(wrapLeft)
        },
        repeat: -1
      })
    },
    getImgPath (img) {
      return `/assets/images/lot1/${img}`
    }
  }
}

</script>

<style lang="scss" scoped>
.thumbnailCard{
  @include flex(row, flex-start, flex-start);
  width: 100%;
  max-width: 600px;
  overflow: visible;
  @media screen and (max-width: 1300px){
    max-width: 500px
  }
  @media screen and (max-width: 1150px){
    max-width: 400px
  }
  @include mq($until: smd){
    max-width: 100%;
    margin-left: 15px;
  }
  &__wrapper{
    position: relative;
    width: 100%;
    height: 100%;
    @include flex(column, flex-start, flex-start);
    flex-wrap: nowrap;
    @include mq($until: smd){
      flex-direction: row;
      margin: 0;
      justify-content: flex-start;
      flex-shrink: 0;
      width: auto;
      &--left{
        margin-top: 0 !important;
      }
    }
    &--left{
      margin-right: 15px;
    }
  }
  &__card{
    @include flex(column, flex-start, flex-start);
    margin-bottom: 15px;
    position: absolute;
    @include mq($until: smd){
      position: relative;
      flex-shrink: 0;
      margin-bottom: 0;
      margin-right: 15px;
      width: auto;
      img{
        height: 180px;
        width: auto;
      }
    }
    &__img{
      width: auto;
      height: 330px;
      object-fit: contain;
      background-color: #c0bfbf;
      border-radius: 10px;
      @media screen and (max-width: 1150px){
        height: 280px;
      }
      @include mq($until: smd){
        max-width: 130px;
        height: auto;
      }
    }
    &__title{
      text-align: left;
      position: absolute;
      bottom: 20px;
      background-color: white;
      padding: 8px 15px;
      color: black;
      border-left: 5px solid color(primary);
      font-family: 'hernandezniu-regular', sans-serif;
      font-size: 13px;
      @include mq($until: smd){
        font-size: 10px;
        padding: 4px 10px;
      }
    }
  }
}
</style>
